import { render } from "./uint256Box.vue?vue&type=template&id=5efcbc05"
import script from "./uint256Box.vue?vue&type=script&lang=js"
export * from "./uint256Box.vue?vue&type=script&lang=js"

import exportComponent from "/home/mitch/frontend/demoenv/demo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__